import React from 'react';
import { IntlShape } from 'react-intl';
import { useT } from '@transifex/react';
import { PressMediaArticleCard, PressReleaseCard } from '@raisin/components-lib';
import { getLocale, shouldEnableUnifiedDomain } from '@raisin/cp-utils';
import { PageTemplateProps } from 'types';
import messages from '../../messages';
import { Pagination } from '../components';
import { useBuildTabContent } from './';

export const useBuildPressPageTabs = (
  pressReleases: PageTemplateProps['pressReleases'],
  mediaArticles: PageTemplateProps['mediaArticles'],
  intl: IntlShape,
) => {
  const t = useT();
  const {
    tabContent: pressReleasesTabContent,
    currentPage: currentPressReleasesPage,
    handlePaginationPage: handlePressReleasesPaginationChange,
  } = useBuildTabContent(pressReleases);

  const {
    tabContent: mediaArticlesTabContent,
    currentPage: currentMediaArticlesPage,
    handlePaginationPage: handleMediaArticlesPaginationChange,
  } = useBuildTabContent(mediaArticles);

  return [
    {
      id: 'press-releases-tab',
      label: t(messages.pressReleasesTabLabel),
      content: (
        <>
          {pressReleasesTabContent.map((pressRelease) => {
            const { url } = pressRelease;
            const pressReleaseUrl = shouldEnableUnifiedDomain(intl.locale.toLowerCase())
              ? `/${getLocale(intl.locale)['cmsFormat']}${url}`
              : url;

            return (
              <PressReleaseCard key={pressReleaseUrl} {...pressRelease} url={pressReleaseUrl} />
            );
          })}
          <Pagination
            content={pressReleases}
            page={currentPressReleasesPage}
            onChange={handlePressReleasesPaginationChange}
          />
        </>
      ),
    },
    {
      id: 'in-the-media-tab',
      label: t(messages.inTheMediaTabLabel),
      content: (
        <>
          {mediaArticlesTabContent.map((mediaArticle) => (
            <PressMediaArticleCard key={mediaArticle.article_link.href} {...mediaArticle} />
          ))}
          <Pagination
            content={mediaArticles}
            page={currentMediaArticlesPage}
            onChange={handleMediaArticlesPaginationChange}
          />
        </>
      ),
    },
  ];
};
